export default [
  { name: "Account Admin", value: "account_admin" },
  { name: "Account Viewer", value: "account_viewer" },
  { name: "Worksite Admin", value: "site_admin" },
  { name: "Operator", value: "operator" },
];
